var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-fab",on:{"click":_vm.openWhatsApp}},[_c('div',{staticClass:"bubble"},[_vm._v(_vm._s(_vm.$t('needHelp')))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":require("@/assets/img/whatsapp.png")}})])
}]

export { render, staticRenderFns }